import React from 'react'
import { Box } from '@workwhile/ui'
import { FieldglassIssuesFilterBar } from 'pages/Fieldglass/shared/components/FieldglassIssuesFilterBar'
import { useFieldglassReferenceDataContextValue } from 'pages/Fieldglass/shared/context/FieldglassReferenceDataProvider'
import { useFieldglassShiftIssuesContextValue } from '../context/FieldglassShiftIssuesProvider'
import { FieldglassShiftIssuesHeader } from './FieldglassShiftIssuesHeader'
import { FieldglassShiftIssuesTable } from './FieldglassShiftIssuesTable'

export const FieldglassShiftIssuesMain = () => {
  const {
    state: { companyGroups },
  } = useFieldglassReferenceDataContextValue()
  const {
    state: { filters },
    actions: { setFilters },
  } = useFieldglassShiftIssuesContextValue()

  return (
    <>
      <FieldglassShiftIssuesHeader />
      <FieldglassIssuesFilterBar
        companyGroups={companyGroups}
        filters={filters}
        setFilters={setFilters}
      />
      <Box margin={3}>
        <FieldglassShiftIssuesTable />
      </Box>
    </>
  )
}
